



























































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import CompanyApi from '../store/api/CompanyApi';
import ICompany from '@/store/models/ICompany';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '../store/api/WarehouseApi';
import GoodsMovementsSelector from '@/components/selectors/Movements/GoodsMovementsSelector.vue';
import IGoodsMovements from '@/store/models/IGoodsMovements';
import GoodsMovementApi from '@/store/api/GoodsMovementsApi';
import IGoodsMovementsDetail from '@/store/models/IGoodsMovementsDetail';
import GoodsMovementsDetailApi from '@/store/api/GoodsMovementsDetailApi';
import StockApi from '@/store/api/StockApi';
import IStock from '@/store/models/IStock';
import GoodsMovementsDetailSelector from '@/components/selectors/Movements/GoodsMovementsDetailSelector.vue';
import IGoods from '@/store/models/IGood';
import IListPalletType from '@/store/models/IListPalletType';
import GoodApi from '@/store/api/GoodApi';
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import PrintingApi from '@/store/api/PrintingApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import UploadServiceApi from '../store/api/UploadServiceApi';
import ListStatusGoodsMovementsApi from '@/store/api/ListStatusGoodsMovementsApi';
import IListStatusGoodsMovements from '@/store/models/IListStatusGoodsMovements';
import GoodsMovementsApi from '../store/api/GoodsMovementsApi';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        Snackbar,
        GoodsMovementsSelector,
        GoodsMovementsDetailSelector
    }
})
export default class Movements extends Vue {
    // PersonSelector
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    companyApi : CompanyApi;
    companyList : ICompany[] = [];
    warehouseApi: WarehouseApi;
    warehouseList : IWarehouse[] = [];
    movementList : IGoodsMovements[] = []
    goodsMovementsApi : GoodsMovementApi;
    movementDetailList : IGoodsMovementsDetail[] = []
    goodsMovementsDetailApi : GoodsMovementsDetailApi;
    selectedMovement : IGoodsMovements | null = null;
    activeTab : number = 0;
    stockCompanyList : IStock[] = [];
    stockApi : StockApi;
    goodsList : IGoods[] = [];
    goodsApi : GoodApi;
    palletTypeList : IListPalletType[] = [];
    listPalletTypesApi : ListPalletTypesApi;
    enableTabsItem: boolean = false;
    printingApi : PrintingApi;
    settingsCompanyApi: SettingsCompanyApi;
    uploadServiceApi : UploadServiceApi;
    MovementCodeSelectedFromDashboard : string = "";
    overlay: boolean = false;
    listStatusGoodsMovementsApi : ListStatusGoodsMovementsApi;
    isStandAlone: boolean = false;
    completedGoodsMovements : boolean = false;
    scannerActive : boolean = false;
    companyLicensesApi : CompanyLicensesApi;
    constructor() {
        super();
        this.companyApi = new CompanyApi();
        this.warehouseApi = new WarehouseApi();
        this.goodsMovementsApi = new GoodsMovementApi();
        this.listStatusGoodsMovementsApi = new ListStatusGoodsMovementsApi();
        this.stockApi = new StockApi();
        this.goodsMovementsDetailApi = new GoodsMovementsDetailApi();
        this.goodsApi = new GoodApi();
        this.listPalletTypesApi = new ListPalletTypesApi();
        this.printingApi = new PrintingApi("Movements");
        this.settingsCompanyApi = new SettingsCompanyApi("Movements");
        this.uploadServiceApi = new UploadServiceApi("Movements");
        this.companyLicensesApi = new CompanyLicensesApi();
    }

    created() {
        this.getPermissions();
        this.getCompanies();
        this.getGoodsMovements();
        // this.getStatusGoodsMovements();
        this.getWarehouses();
        this.getStockCompany();
        this.getGoods();
        this.getListPalletTypes();
    }

    @Watch('movementList')
    onChangeMovementList() {
        let index = this.movementList.findIndex(i => i.id === this.$route.params.data);
        if (index !== -1) {
            this.MovementCodeSelectedFromDashboard = this.movementList[index].code;
        } else {
            index = this.movementList.findIndex(i => i.code === this.$route.params.data);
            if (index !== -1) {
                this.MovementCodeSelectedFromDashboard = this.movementList[index].code;
            }
        }
    }

    async showCompletedGoodsMovements(completedGoodsMovements : boolean) {
        this.overlay = true;
        if (completedGoodsMovements) {
            this.movementList = [];
            this.movementList = await this.goodsMovementsApi.GetGoodsMovementsCompleted(this.idCompany);
        } else {
            if (this.completedGoodsMovements) {
                this.movementList = [];
                this.getGoodsMovements();
            }
        }
        this.completedGoodsMovements = completedGoodsMovements;
        this.overlay = false;
    }

    // get StatusGoodsMovementsCompleted() {
    //    let index = this.StatusGoodsMovementsList.findIndex(s => s.name.toLowerCase() === 'completed');
    //    return this.StatusGoodsMovementsList[index].id;
    // }

    get isSuperAdmin() {
        return this.idCompany === EMPTY_GUID;
    }

    // async getStatusGoodsMovements() {
    //    this.StatusGoodsMovementsList = await this.listStatusGoodsMovementsApi.GetListStatusGoodsMovements();
    // }

    async getGoods() {
        this.goodsList = await this.goodsApi.GetGoods();
    }

    async getListPalletTypes() {
        this.palletTypeList = await this.listPalletTypesApi.GetListPalleTypes();
    }

    @Watch('warehouseList')
    async getStockCompany() {
        if (this.warehouseList) {
            let ids : string[] = this.warehouseList.map(w => w.id);
            if (ids.length > 0) {
                this.stockCompanyList = await this.stockApi.GetStockGroupByWarehousesId(ids, this.idCompany, this.scannerActive);
            }
        }
    }

    async onChangeSelectedMovement(movement : IGoodsMovements[]) {
        this.overlay = true;
        if (movement.length > 0) {
            this.enableTabsItem = true;
            this.movementDetailList = await this.goodsMovementsDetailApi.GetGoodsMovementsDetail(movement[0].id);
        } else {
            this.selectedMovement = null;
            this.enableTabsItem = false;
        }
        this.overlay = false;
    }

    async getGoodsMovements() {
        this.movementList = await this.goodsMovementsApi.GetGoodsMovements(this.idCompany);
    }

    async getCompanies() {
        this.companyList = await this.companyApi.GetCompaniesById(this.idCompany);
        this.companyList.sort((a, b) => a.name.localeCompare(b.name));
    }

    async getWarehouses() {
        this.warehouseList = await this.warehouseApi.GetWarehousesShared(this.idCompany);
        this.warehouseList.sort((a, b) => a.name.localeCompare(b.name));
    }

    async resetMovement() {
        this.selectedMovement = null;
        this.movementDetailList = [];
        await this.$emit('getStockCompany');
    }

    deleteMovement (item: IGoodsMovements) {
        confirm('Are you sure you want to delete this good movement?') && this.deleteGoodMovementItem(item);
    }

    async deleteGoodMovementItem(goodMovement: IGoodsMovements) {
        this.overlay = true;
        let resultDetail: any = this.goodsMovementsDetailApi.DeleteGoodsMovementsDetailByMovementId(goodMovement.id);
        if (resultDetail) {
            let result: boolean = await this.goodsMovementsApi.DeleteGoodsMovements(goodMovement.id);
            if (result) {
                const index = this.movementList.indexOf(goodMovement);
                this.movementList.splice(index, 1);
                this.showMessageInfo(`The good movement has been successfully deleted`);
            } else {
                const errors: string = this.goodsMovementsApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.overlay = false;
    }

    async saveMovement (movement: IGoodsMovements, stockList : IStock[]) {
        this.overlay = true;
        if (!movement.id) {
            const id = await this.goodsMovementsApi.SaveGoodsMovements(movement);
            if (id) {
                const details = await Promise.all(
                    stockList.map(async s => {
                        const movementDetail = this.CreateMovementDetail(s, id);
                        const idMovementDetail = await this.goodsMovementsDetailApi.SaveGoodsMovementsDetail(movementDetail);
                        movementDetail.id = idMovementDetail;
                        return movementDetail;
                    })
                );
                this.movementDetailList = [...details, ...this.movementDetailList];
                movement.id = id;
                let indexCompanySourceWarehouseName = this.companyList.findIndex(w => w.id === movement.idCompanySourceWarehouse);
                movement.companySourceWarehouseName = this.companyList[indexCompanySourceWarehouseName].name;
                let indexCompanyDestinationWarehouseName = this.companyList.findIndex(w => w.id === movement.idCompanyDestinationWarehouse);
                movement.companyDestinationWarehouseName = this.companyList[indexCompanyDestinationWarehouseName].name;
                let indexWarehouseDestinationName = this.warehouseList.findIndex(w => w.id === movement.idWarehouseDestination);
                movement.warehouseDestinationName = this.warehouseList[indexWarehouseDestinationName].name;
                let indexWarehouseSourceName = this.warehouseList.findIndex(w => w.id === movement.idWarehouseSource);
                movement.warehouseSourceName = this.warehouseList[indexWarehouseSourceName].name;
                this.movementList = [movement].concat(this.movementList);
                this.selectedMovement = movement;
                this.showMessageInfo(`The movement has been successfully saved`);
                await this.getStockCompany();
            } else {
                const errors: string = this.goodsMovementsApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        } else {
            this.editMovement(movement);
            if (stockList.length > 0) {
                this.editStockDetail(stockList);
            }
        }
        this.overlay = false;
    }

    async completeMovement(movementId: string) {
        this.overlay = true;
        const response = await this.goodsMovementsApi.CompleteMovement(movementId);
        if (response) {
            this.showMessageInfo(`The movement has been successfully completed`);
        }
        this.overlay = false;
    }

    async editMovement(movement : IGoodsMovements) {
        this.overlay = true;
        let result : boolean = await this.goodsMovementsApi.UpdateGoodsMovements(movement);
        if (result) {
            let index = this.movementList.findIndex(m => m.id === movement.id);
            Object.assign(this.movementList[index], movement);
            this.showMessageInfo(`The movement has been successfully edited`);
        } else {
            const errors: string = this.goodsMovementsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editStockDetail (stockList : IStock[]) {
        this.overlay = true;
        if (this.selectedMovement) {
            const details = await Promise.all(
                stockList.map(async s => {
                    const movementDetail = this.CreateMovementDetail(s, this.selectedMovement!.id);
                    const idMovementDetail = await this.goodsMovementsDetailApi.SaveGoodsMovementsDetail(movementDetail);
                    movementDetail.id = idMovementDetail;
                    return movementDetail;
                })
            );
            this.movementDetailList.push(...details);
            await this.getStockCompany();
        }
        
        this.showMessageInfo(`The movement has been successfully edited`);
        this.overlay = false;
    }

    CreateMovementDetail(stockDetail : IStock, idGoodsMovement : string) {
        let movementDetail : IGoodsMovementsDetail = {} as IGoodsMovementsDetail;
        movementDetail.idGoodsMovement = idGoodsMovement;
        movementDetail.totalGoods = stockDetail.totalGoods;
        let indexGood = this.goodsList.findIndex(l => l.name === stockDetail.goodName);
        movementDetail.idGood = this.goodsList[indexGood].id;
        movementDetail.goodName = stockDetail.goodName;
        let indexPalletList = this.palletTypeList.findIndex(l => l.name === stockDetail.listPalletName);
        movementDetail.idListPallet = this.palletTypeList[indexPalletList].id;
        movementDetail.listPalletName = stockDetail.listPalletName;
        movementDetail.casesPerPallet = stockDetail.totalCases;
        movementDetail.goodsPerCase = stockDetail.goodsPerCase;
        movementDetail.idPallet = stockDetail.idPallet;
        return movementDetail;
    }

    deleteMovementDetail (item: IGoodsMovementsDetail) {
        confirm('Are you sure you want to delete this good movement detail?') && this.deleteGoodMovementDetailItem(item);
    }

    async deleteGoodMovementDetailItem(goodMovementDetail: IGoodsMovementsDetail) {
        this.overlay = true;
        let result: boolean = await this.goodsMovementsDetailApi.DeleteGoodsMovementsDetail(goodMovementDetail.id);
        if (result) {
            const index = this.movementDetailList.indexOf(goodMovementDetail);
            this.movementDetailList.splice(index, 1);
            this.showMessageInfo(`The good movement detail has been successfully deleted`);
        } else {
            const errors: string = this.goodsMovementsDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async printMovementDetail(formatToPrint : string) {
        this.overlay = true;
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdGoodsMovementPrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
            if (idRepport) {
                let ids : string[] = [this.selectedMovement!.id];
                let printLabelUrl: string = await this.printingApi.Print(idRepport[0].value, "IdGoodsMovement", ids, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "GoodsMovement.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
        this.overlay = false;
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Users"));
        let settingsCompany = SettingsCompany.Settings.StandAlone;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.isStandAlone = true;
            }
        }
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.idCompany);
        let hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        if (!hasLicenseScanner) {
            this.scannerActive = true;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.Scanner);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
